import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URLS } from "./apis/urls";
import Api from "./utils/apiCall";

interface EmployeesWorkScheduleState {
  data: any;
  summary: any;
  loading: "idle" | "pending" | "fulfilled" | "rejected";
  error: string | null;
  action: "list" | "get" | "update" | null;
}

const EmployeesWorkScheduleStateInitialState: EmployeesWorkScheduleState = {
  data: null,
  summary: null,
  loading: "idle",
  error: null,
  action: null,
};

export const getEmployeesWorkSchedule: any = createAsyncThunk(
  "get/employees-work-schedule",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.EMPLOYEES.EMPLOYEE_WORK_SCHEDULE, payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);



const employeesWorkScheduleSlice = createSlice({
  name: "reset",
  initialState: EmployeesWorkScheduleStateInitialState,
  reducers: {
    resetAll: (state: any) => {
      state.loading = "idle";
      state.error = null;
      state.data = null;
      state.action = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getEmployeesWorkSchedule.pending, (state) => {
      state.loading = "pending";
      state.data = null;
      state.error = null;
      state.action = "list";
    });
    builder.addCase(getEmployeesWorkSchedule.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.data = action.payload;
      state.error = null;
      state.action = "list";
    });
    builder.addCase(getEmployeesWorkSchedule.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.data = null;
      state.action = "list";
    });
  },
});

export const { resetAll } = employeesWorkScheduleSlice.actions;
export default employeesWorkScheduleSlice.reducer;
